import { render, staticRenderFns } from "./openAliPayWithholdConfig.vue?vue&type=template&id=6fa93b96"
import script from "./openAliPayWithholdConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./openAliPayWithholdConfig.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports